/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import {
	Fragment,
	useEffect,
	useRef,
} from '@wordpress/element'
import $ from 'jquery'
import { i18n, pluginAssetsURL } from 'cartzillagb'
import {
	PanelBody, ToggleControl, RangeControl, SelectControl
} from '@wordpress/components'
import {
	RichText 
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'

/**
 * External dependencies
 */
import {
	BackgroundSettings, ButtonControlsHelper, ButtonEditHelper
} from '~cartzillagb/components'
import { withTabbedInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'

addFilter( 'cartzillagb.hero-carousel.edit.inspector.style.before', 'czgb/hero-carousel', ( output, props ) => {
	const { 
		attributes,
		setAttributes,
		clientId,
	} = props

	const {
		blockId,
		limit,
		enableButton,
		autoplay
	} = props.attributes

	const slideLimitUpdate = limit => {
		if ( $( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${blockId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )
		} else if ( $( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( `#${clientId}` ).find( '.js-slick-carousel.slick-initialized' ).slick( 'unslick' )

		}

		setAttributes( { limit } )
	}

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true }>
				<RangeControl
					label={ __( 'No Of Slides', i18n ) }
					value={ limit }
					onChange={ limit => { slideLimitUpdate( limit ) } }
					min={ 1 }
					max={ applyFilters( 'cartzillagb.hero-carousel.edit.inspector.max.limit', 5 ) }
				/>
				<ToggleControl
					label={ __( 'Enable Autoplay?', i18n ) }
					checked={ autoplay }
					onChange={ autoplay => setAttributes( { autoplay } ) }
				/>
			</PanelBody>
			<Fragment>
				{ range( 1, limit + 1 ).map( i => {
				const bgColor = attributes[ `bgcolor${ i }` ]
				const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
				const enablepreTitle = attributes[ `enablepreTitle${ i }` ]
				const enableTitle = attributes[ `enableTitle${ i }` ]
				const enablesubTitle = attributes[ `enablesubTitle${ i }` ]

				let defaultBackgroundImage = ''

				if ( i % 5 === 1 ) {
				   defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img1.jpg`
				} 
				if ( i % 5 === 2 ) {
					defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img2.jpg`
				} 
				if ( i % 5 === 3 ) {
					defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img3.jpg`
				} 
				if ( i % 5 === 4 ) {
					defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img1-1.jpg`
				} 
				if ( i % 5 === 0 ) {
					defaultBackgroundImage = `${ pluginAssetsURL }img/hero-slider/img2-1.jpg`
				}

				return (
					<Fragment key={ i }>
						<PanelBody title={ __( 'Slide Settings #', i18n ) + i } initialOpen={ i === 1 ? true : false } key={ i }>
							<BackgroundSettings
								backgroundImageURL={ attributes[`mediaURL${ i }`] !== undefined ? attributes[`mediaURL${ i }`] : defaultBackgroundImage }
								onChangeBackgroundImage={ ( { url } ) => setAttributes( { [`mediaURL${ i }`]: url } ) }
								onRemoveBackgroundImage={ () => { setAttributes( { [`mediaURL${ i }`]: '' } ) } }
							/>

							<BackgroundSettings 
								background={ bgColor !== undefined ? bgColor : ' bg-primary' }
								backgroundColor={ bgcustomColor }
								onChangeBackground={ bgColor => setAttributes( { [ `bgcolor${ i }` ]: ` ${ bgColor }`, [ `bgcustomcolor${ i }` ]: '' } ) }
								onChangeBackgroundColor={ bgcustomColor => setAttributes( { [ `bgcustomcolor${ i }` ]: bgcustomColor.hex, [ `bgcolor${ i }` ]: '' } ) }
								onRemoveBackground={ () => { setAttributes( { [ `bgcolor${ i }` ]: '', [ `bgcustomcolor${ i }` ]: '' } ) } }
							/>

							<ToggleControl
								label={ __( 'Enable Pretitle', i18n ) }
								checked={ enablepreTitle }
								onChange={ enablepreTitle => setAttributes( { [ `enablepreTitle${ i }` ]: enablepreTitle } ) }
							/>

							<ToggleControl
								label={ __( 'Display Title', i18n ) }
								checked={ enableTitle }
								onChange={ enableTitle => setAttributes( { [ `enableTitle${ i }` ]: enableTitle } ) }
							/>

							<ToggleControl
								label={ __( 'Display Subtitle', i18n ) }
								checked={ enablesubTitle }
								onChange={ enablesubTitle => setAttributes( { [ `enablesubTitle${ i }` ]: enablesubTitle } ) }
							/>
							<ToggleControl
								label={ __( 'Display Button', i18n ) }
								checked={ enableButton }
								onChange={ enableButton => setAttributes( { enableButton } ) }
							/>
						</PanelBody>
						<PanelBody title={ __( 'Animation #', i18n ) + i } initialOpen={ false } key={ i }>
							<SelectControl
								label={ __( 'Pre-Title Animation' ) }
								value={ attributes[ `pretitleAnimation${ i }` ] }
								options={ [
									{ label: __('None', 'cartzilla', i18n ), value: 'none' },
									{ label: __('From Left', 'cartzilla', i18n ), value: 'from-left' },
									{ label: __('From Right', 'cartzilla', i18n ), value: 'from-right' },
									{ label: __('From Top', 'cartzilla', i18n ), value: 'from-top' },
									{ label: __('From Bottom', 'cartzilla', i18n ), value: 'from-bottom' },
									{ label: __('Scale Up', 'cartzilla', i18n ), value: 'scale-up' },
								] }
								onChange={ value => setAttributes( {  [ `pretitleAnimation${ i }` ] : value } ) }
							/>

							<SelectControl
								label={ __( 'Pre-Title Delay' ) }
								value={ attributes[ `pretitleDelay${ i }` ] }
								options={ [
									{ label: __('None', 'cartzilla', i18n ), value: 'none' },
									{ label: __('Delay-1', 'cartzilla', i18n ), value: 'delay-1' },
									{ label: __('Delay-2', 'cartzilla', i18n ), value: 'delay-2' },
									{ label: __('Delay-3', 'cartzilla', i18n ), value: 'delay-3' },
									{ label: __('Delay-4', 'cartzilla', i18n ), value: 'delay-4' },
								] }
								onChange={ value => setAttributes( {  [ `pretitleDelay${ i }` ] : value } ) }
							/>

							<SelectControl
								label={ __( 'Title Animation' ) }
								value={ attributes[ `titleAnimation${ i }` ] }
								options={ [
									{ label: __('None', 'cartzilla', i18n ), value: 'none' },
									{ label: __('From Left', 'cartzilla', i18n ), value: 'from-left' },
									{ label: __('From Right', 'cartzilla', i18n ), value: 'from-right' },
									{ label: __('From Top', 'cartzilla', i18n ), value: 'from-top' },
									{ label: __('From Bottom', 'cartzilla', i18n ), value: 'from-bottom' },
									{ label: __('Scale Up', 'cartzilla', i18n ), value: 'scale-up' },
								] }
								onChange={ value => setAttributes( {  [ `titleAnimation${ i }` ] : value } ) }
							/>

							<SelectControl
								label={ __( 'Title Delay' ) }
								value={ attributes[ `titleDelay${ i }` ] }
								options={ [
									{ label: __('None', 'cartzilla', i18n ), value: 'none' },
									{ label: __('Delay-1', 'cartzilla', i18n ), value: 'delay-1' },
									{ label: __('Delay-2', 'cartzilla', i18n ), value: 'delay-2' },
									{ label: __('Delay-3', 'cartzilla', i18n ), value: 'delay-3' },
									{ label: __('Delay-4', 'cartzilla', i18n ), value: 'delay-4' },
								] }
								onChange={ value => setAttributes( {  [ `titleDelay${ i }` ] : value } ) }
							/>

							<SelectControl
								label={ __( 'SubTitle Animation' ) }
								value={ attributes[ `subtitleAnimation${ i }` ] }
								options={ [
									{ label: __('None', 'cartzilla', i18n ), value: 'none' },
									{ label: __('From Left', 'cartzilla', i18n ), value: 'from-left' },
									{ label: __('From Right', 'cartzilla', i18n ), value: 'from-right' },
									{ label: __('From Top', 'cartzilla', i18n ), value: 'from-top' },
									{ label: __('From Bottom', 'cartzilla', i18n ), value: 'from-bottom' },
								] }
								onChange={ value => setAttributes( {  [ `subtitleAnimation${ i }` ] : value } ) }
							/>

							<SelectControl
								label={ __( 'SubTitle Delay' ) }
								value={ attributes[ `subtitleDelay${ i }` ] }
								options={ [
									{ label: __('None', 'cartzilla', i18n ), value: 'none' },
									{ label: __('Delay-1', 'cartzilla', i18n ), value: 'delay-1' },
									{ label: __('Delay-2', 'cartzilla', i18n ), value: 'delay-2' },
									{ label: __('Delay-3', 'cartzilla', i18n ), value: 'delay-3' },
									{ label: __('Delay-4', 'cartzilla', i18n ), value: 'delay-4' },
								] }
								onChange={ value => setAttributes( {  [ `subtitleDelay${ i }` ] : value } ) }
							/>
						</PanelBody>
						<PanelBody title={ __( 'Button Settings #', i18n ) + i }initialOpen={ false } >
							<ButtonControlsHelper
								attrNameTemplate={ `button${ i }%s"` }
								setAttributes={ setAttributes }
								blockAttributes={ props.attributes }
							/>
						</PanelBody>
					</Fragment>
				)
			} ) }
			</Fragment>
		</Fragment>
	)
} )

const edit = props => {
	const { 
		attributes, 
		setAttributes, 
		className,
		clientId,
	} = props 

	const {
		blockId,
		limit,
		enableButton,
		autoplay
	} = attributes

	const slickEl = useRef(clientId)
	const setBlockId = blockId => setAttributes({blockId})

	if ( clientId !== blockId ) {
		setBlockId( clientId )
	}

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				slidesToShow: limit,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true )
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' )
		}
	}, [limit] )

	useEffect( () => {
		if ( slickEl.current && $( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'setOption', {
				autoplay: attributes.autoplay,
			}, true )
			$( slickEl.current ).find( '.js-slick-carousel.slick-initialized' ).slick( 'refresh' )
		} else if ( $( '.cz-carousel' ).find( '.js-slick-carousel' ).length ) {
			$( slickEl.current ).find( '.js-slick-carousel' ).slick()
			$( slickEl.current ).find( '.js-slick-carousel' ).slick('setOption', 'rtl', $('body,html').hasClass('rtl'), true )
            $( slickEl.current ).find( '.js-slick-carousel' ).slick( 'refresh' )
		}
	}, [autoplay] )

	const mainClasses = classnames( [
		className,
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const content = range( 1, limit + 1 ).map( i => {

		const Pretitle = attributes[ `pretitle${ i }` ]
		const Title = attributes[ `title${ i }` ]
		const subTitle = attributes[ `subtitle${ i }` ]
		const MediaURL = attributes[ `mediaURL${ i }` ]
		const bgColor = attributes[ `bgcolor${ i }` ]
		const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
		const enablepreTitle = attributes[ `enablepreTitle${ i }` ]
		const enableTitle = attributes[ `enableTitle${ i }` ]
		const enablesubTitle = attributes[ `enablesubTitle${ i }` ]

		let defaultPretitle = ''
		let defaultTitle = ''
		let defaultSubtitle = ''
		let defaultImg = ''
		let defaultbgColor = ''

		if ( i % 5 === 1 ) {
			defaultPretitle = 'Has just arrived!'
			defaultTitle = 'Huge Summer Collection'
			defaultSubtitle = 'Swimwear, Tops, Shorts, Sunglasses & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img1.jpg`
			defaultbgColor = 'rgb(58, 175, 210)'
		}
		if ( i % 5 === 2 ) {
			defaultPretitle = 'Hurry up! Limited time offer.'
			defaultTitle = 'Women Sportswear Sale'
			defaultSubtitle = 'Sneakers, Keds, Sweatshirts, Hoodies & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img2.jpg`
			defaultbgColor = 'rgb(245, 177, 176)'
		}
		if ( i % 5 === 3 ) {
			defaultPretitle = 'Complete your look with'
			defaultTitle = 'New Mens Accessories'
			defaultSubtitle = 'Sneakers, Keds, Sweatshirts, Hoodies & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img3.jpg`
			defaultbgColor = 'rgb(235, 161, 112)'
		}
		if ( i % 5 === 4 ) {
			defaultPretitle = 'Has just arrived!'
			defaultTitle = 'Huge Summer Collection'
			defaultSubtitle = 'Swimwear, Tops, Shorts, Sunglasses & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img1-1.jpg`
			defaultbgColor = 'rgb(58, 175, 210)'
		}
		if ( i % 5 === 0 ) {
			defaultPretitle = 'Hurry up! Limited time offer.'
			defaultTitle = 'Women Sportswear Sale'
			defaultSubtitle = 'Sneakers, Keds, Sweatshirts, Hoodies & much more...'
			defaultImg = `${ pluginAssetsURL }img/hero-slider/img2-1.jpg`
			defaultbgColor = 'rgb(245, 177, 176)'
		}

		const bgstyle = { backgroundColor: bgcustomColor !== undefined ? bgcustomColor : defaultbgColor }

		const pretitleComp = enablepreTitle && (
			<RichText
				tagName="h2"
				value={ Pretitle || defaultPretitle }
				className={ `font-weight-light pb-1 text-light ${ attributes[ `pretitleAnimation${ i }` ] } ${ attributes[ `pretitleDelay${ i }` ] }` }
				onChange={ Pretitle => setAttributes( { [ `pretitle${ i }` ]: Pretitle } ) }
				placeholder={ __( 'pretitle', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const titleComp = enableTitle && (
			<RichText
				tagName="h1"
				className={ `display-4 ${ attributes[ `titleAnimation${ i }` ] } ${ attributes[ `titleDelay${ i }` ] } text-light` } 
				value={ Title || defaultTitle }
				onChange={ Title => setAttributes( { [ `title${ i }` ]: Title } ) }
				placeholder={ __( 'Title', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const subtitleComp = enablesubTitle &&  (
			<RichText
				tagName="p"
				value={ subTitle || defaultSubtitle }
				className={ `font-size-lg pb-3 text-light ${ attributes[ `subtitleAnimation${ i }` ] } ${ attributes[ `subtitleDelay${ i }` ] }` }
				onChange={ subTitle => setAttributes( { [ `subtitle${ i }` ]: subTitle } ) }
				placeholder={ __( 'subtitle', i18n ) }
				keepPlaceholderOnFocus
			/>
		)

		const buttonComp = enableButton &&(
			<ButtonEditHelper
				attrNameTemplate={ `button${ i }%s"` }
				setAttributes={ setAttributes }
				blockAttributes={ props.attributes }
			/>
		)

		const output = (
			<div className={ `slide-wrapper` } key={ i } >
				<div className={ `px-lg-5 bg-color ${ bgColor }` } style={ bgstyle }>
					<div className="d-lg-flex justify-content-between align-items-center pl-lg-4">
						<img className="d-block order-lg-2 mr-lg-n5 flex-shrink-0" src={ MediaURL !== undefined ? MediaURL : defaultImg } alt="Summer Collection" />
						<div className="slider-content position-relative mx-auto mr-lg-n5 py-5 px-4 mb-lg-5 order-lg-1">
							<div className="pb-lg-5 mb-lg-5 text-center text-lg-left text-lg-nowrap">
								{ pretitleComp }
								{ titleComp }
								{ subtitleComp }
								{ buttonComp }
							</div>
						</div>
					</div>
				</div>
			</div>
		)
			
			return output
	}   )

	const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-1.main-block.classes', {
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows : true,
		adaptiveHeight : true,
		prevArrow: '<i class="czi-arrow-left"></i>',
		nextArrow: '<i class="czi-arrow-right"></i>',
		autoplay: autoplay,
		pauseOnHover: true,
		responsive: [
			{
				breakpoint: 0,
				settings: {
					nav: true,
					controls: false
				}
			},
			{
				breakpoint: 992,
				settings: {
					nav: false,
					controls: true
				}
			},
		],
	}, props )

	let carouselOptions = {
		dots: false,
		fade: true,
		mode: "gallery",
		speed: 1000,
	}

	carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

	const wraperAttr = {}

	wraperAttr.className = classnames( [
		'cz-carousel',
		'cz-controls-lg',
	] )

	return (
		<div ref={ slickEl } id={ blockId || clientId } className={ mainClasses }>
			<div { ...wraperAttr }>
				<div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
					{ content }
				</div>
			</div>
		</div>
	)
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )
